import ComponentPortals from './ComponentPortals';

const RemoveSsrPageLoader = () => {
    return <ComponentPortals cmpName="SsrPageLoader" render={() => null} />;
};

export default RemoveSsrPageLoader;
